import { render } from "./PersonPhoto.vue?vue&type=template&id=71356472&scoped=true&ts=true"
import script from "./PersonPhoto.vue?vue&type=script&lang=ts"
export * from "./PersonPhoto.vue?vue&type=script&lang=ts"

import "./PersonPhoto.vue?vue&type=style&index=0&id=71356472&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71356472"]])

export default __exports__